import React, { Fragment } from 'react';
import { string, number, arrayOf, shape } from 'prop-types';
import AmpImg from 'components/AmpImg';
import { getAffiliateLinkProps } from 'util/affiliates/amazon';
import styles from './styles';

const SPONSORED = 'sponsored';

function AmpProductTeaserListItem(props) {
  const {
    description,
    imageUrl,
    name,
    num,
    price,
    retailerName,
    salePrice,
    subtitle,
    tags,
    total,
    url
  } = props;

  if (!name && !url) {
    return null;
  }

  const linkProps = getAffiliateLinkProps(url);

  const isSponsored = tags && tags.map(t => t.slug).includes(SPONSORED);

  return (
    <div className="AmpProductTeaserListItem">
      {imageUrl && (
        <Fragment>
          <a
            rel="nofollow"
            target="_blank"
            {...linkProps}
            className="AmpProductTeaserListItem__image"
          >
            <AmpImg
              url={imageUrl}
              maxSize={{
                aspectRatio: 1,
                width: 250
              }}
              originalHeight={600}
              originalWidth={600}
              alt={`Product Image: ${name}`}
            />
          </a>

          <div className="AmpProductTeaserListItem__counter">
            {num} / {total}
          </div>
        </Fragment>
      )}
      <div className="AmpProductTeaserListItem__body">
        {isSponsored && (
          <div className="AmpProductTeaserListItem__cake">SPONSORED</div>
        )}

        {subtitle && (
          <div
            className="AmpProductTeaserListItem__subtitle"
            data-test="AmpProductSubtitle"
          >
            {subtitle}
          </div>
        )}

        <div className="AmpProductTeaserListItem__name">
          <a rel="nofollow" target="_blank" {...linkProps}>
            {name}
          </a>
        </div>

        {retailerName && (
          <div className="AmpProductTeaserListItem__retailer">
            {retailerName}
          </div>
        )}

        {(salePrice > 0 || price > 0) && (
          <div className="AmpProductTeaserListItem__price">
            ${((salePrice || price) / 100).toFixed(2)}
          </div>
        )}

        {price > 0 && salePrice > 0 && (
          <div className="AmpProductTeaserListItem__comparisonPrice">
            was ${(price / 100).toFixed(2)}
          </div>
        )}

        {description && (
          <div
            className="AmpProductTeaserListItem__description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </div>

      <a rel="nofollow" target="_blank" {...linkProps}>
        <div className="AmpProductTeaserListItem__cta" aria-label="buy now">
          Buy Now
        </div>
      </a>

      <style jsx>{styles}</style>
    </div>
  );
}

AmpProductTeaserListItem.defaultProps = {
  description: undefined,
  imageUrl: undefined,
  num: undefined,
  price: undefined,
  retailerName: undefined,
  salePrice: undefined,
  subtitle: undefined,
  tags: undefined,
  total: undefined
};

AmpProductTeaserListItem.propTypes = {
  description: string,
  name: string.isRequired,
  num: number,
  imageUrl: string,
  price: number,
  retailerName: string,
  salePrice: number,
  subtitle: string,
  tags: arrayOf(
    shape({
      slug: string.isRequired
    })
  ),
  total: number,
  url: string.isRequired
};

export default AmpProductTeaserListItem;
